import { createIcon } from './createIcon';

/** Bare "+" — attach, or add another of whatever the row lists. */
export const PlusIcon = createIcon({
  name: 'PlusIcon',
  viewBox: '0 0 16 16',
  size: 15,
  children: (
    <path
      d="M8 2v12M2 8h12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  ),
});

export default PlusIcon;
